import React from 'react';
import classNames from 'classnames';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import RTE from 'shared/components/rte/rte.jsx';

export default React.createClass({
  mixins: [PureRenderMixin],

  render() {
    let { rowIndex, item, columnId } = this.props;
    // let format = item.getIn(['cells', columnId, 'format']);

    const content = item.getIn(['cells', columnId, 'text']) ? (
      <RTE
        ref="rte"
        displayToolbar={false}
        readOnly={true}
        rteState={this._getCellState()}
      />
    ) : null;

    return (
      <div
        key={rowIndex + '-' + columnId + '-drft'}
        className={classNames('csr-item-cell')}
      >
        {content}
      </div>
    );
  },

  _getCellState() {
    let { item, columnId } = this.props;

    return item.getIn(['cells', columnId, 'rteState']);
  },
});
